import { render } from "./MMCouncilTable.vue?vue&type=template&id=55f1fb56"
import script from "./MMCouncilTable.vue?vue&type=script&lang=js"
export * from "./MMCouncilTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__